import styled from 'styled-components'
import { IconButton, ArrowForwardIcon, ArrowBackIcon, ArrowLastIcon, Flex, Heading, Input, Text } from '@pancakeswap/uikit'
import { useTranslation } from '@pancakeswap/localization'

const StyledInput = styled(Input)`
  width: 60px;
  height: 100%;
  margin-left: 5px;
  padding: 0;
  margin-right: 10px;
  &:focus {
    box-shadow: none !important;
  }
`

const CustomTag = styled(Flex)`
  padding: 7px 8px;
  align-items: center;
  gap: 2px;
  height: 24px;
  border-radius: 100px;
  border: 1px solid ${({ theme }) => theme.colors.cardBorder};
  background: linear-gradient(180deg, rgba(243, 238, 255, 0.00) 0%, rgba(243, 238, 255, 0.04) 100%), rgba(147, 130, 255, 0.01);
  box-shadow: 0px 0px 12px 0px ${({ theme }) => theme.colors.cardBorder} inset;
  color: ${({ theme }) => theme.colors.textSubtle};
  text-align: right;
  leading-trim: both;
  text-edge: cap;
  font-family: DM Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 100%;
  text-transform: uppercase; 
`

const StyledIconButton = styled(IconButton)`
  width: 32px;

  :disabled {
    background: none;

    svg {
      fill: ${({ theme }) => theme.colors.cardBorder};

      path {
        fill: ${({ theme }) => theme.colors.cardBorder};
      }
    }
  }
`

interface RoundSwitcherProps {
  isLoading: boolean
  selectedRoundId: string
  mostRecentRound: number
  handleInputChange: (event: any) => void
  handleArrowButtonPress: (targetRound: number) => void
}

const RoundSwitcher: React.FC<React.PropsWithChildren<RoundSwitcherProps>> = ({
  isLoading,
  selectedRoundId,
  mostRecentRound,
  handleInputChange,
  handleArrowButtonPress,
}) => {
  const { t } = useTranslation()
  const selectedRoundIdAsInt = parseInt(selectedRoundId, 10)
  const isLatestRound = selectedRoundIdAsInt === mostRecentRound

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.currentTarget.validity.valid) {
      handleInputChange(e)
    }
  }

  return (
    <Flex alignItems="center" justifyContent="space-between">
      <Flex alignItems="center">
        <Text fontSize='18px'>{t('Round #')}</Text>
        <StyledInput
          pattern="^[0-9]+$"
          inputMode="numeric"
          disabled={isLoading}
          id="round-id"
          name="round-id"
          value={selectedRoundId}
          scale="lg"
          onChange={handleOnChange}
          style={{border: 'none'}}
        />
        {isLatestRound && (
          <CustomTag>
            Latest
          </CustomTag>
          )
        }
      </Flex>
      <Flex alignItems="center">
        <StyledIconButton
          disabled={!selectedRoundIdAsInt || selectedRoundIdAsInt <= 1}
          onClick={() => handleArrowButtonPress(selectedRoundIdAsInt - 1)}
          variant="text"
          scale="sm"
          mr="4px"
          style={{border: 'none'}}
        >
          <ArrowBackIcon />
        </StyledIconButton>
        <StyledIconButton
          disabled={selectedRoundIdAsInt >= mostRecentRound}
          onClick={() => handleArrowButtonPress(selectedRoundIdAsInt + 1)}
          variant="text"
          scale="sm"
          mr="4px"
          style={{border: 'none'}}
        >
          <ArrowForwardIcon />
        </StyledIconButton>
        <StyledIconButton
          disabled={selectedRoundIdAsInt >= mostRecentRound}
          onClick={() => handleArrowButtonPress(mostRecentRound)}
          variant="text"
          scale="sm"
          style={{border: 'none'}}
        >
          <ArrowLastIcon />
        </StyledIconButton>
      </Flex>
    </Flex>
  )
}

export default RoundSwitcher
